import type { Route } from 'react-resource-router';

import { csmSupportWidgetConfigQueryResource } from '@atlassian/csm-chat-widget/src/services/support-widget-config-resource';

/**
 * Adds the widget config relay resource to the route if the feature gate is enabled
 * @param route - The route to wrap.
 * @returns The wrapped route.
 */
export const routeWithAiWidgetConfigResource = (route: Route) => {
	return {
		...route,
		resources: [...(route.resources ?? []), csmSupportWidgetConfigQueryResource],
	};
};
